export default __webpack_public_path__ + "static/media/Factory01.b8c0967a.jpg";